// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__1llrF","toolbar":"Text_toolbar__3tKUf","toolbarButton":"Text_toolbarButton__1LSxg","editor":"Text_editor__1b5T5","flex1":"Text_flex1__3Jr9I"};